import React, { useState } from 'react';
import { 
  ArrowLeft, User, MapPin, Phone, Mail, MessageSquare, Star, Clock, 
  Calendar, Euro, Settings, Eye, Edit, Plus, Trash2, Upload, Camera,
  CheckCircle, XCircle, AlertCircle, Users, Timer, Award, CreditCard,
  FileText, Percent, Save, X, ChevronDown, ChevronUp
} from 'lucide-react';
import ServiceDetail from './ServiceDetail';

const PartnerDetail = ({ partner, onBack }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [editingCommission, setEditingCommission] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [showAddService, setShowAddService] = useState(false);
  const [generalCommission, setGeneralCommission] = useState(partner.generalCommission);
  const [showServiceDetail, setShowServiceDetail] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  // Données des prestations détaillées
  const [services, setServices] = useState([
    {
      id: 'service-001',
      name: 'Day Charter',
      description: 'Charter privé de jour avec équipage professionnel',
      duration: '8 heures',
      minAge: 0,
      maxAge: null,
      minGuests: 2,
      maxGuests: 12,
      price: 2500,
      currency: 'EUR',
      commission: null, // null = utilise la commission générale
      conditions: 'Permis bateau requis pour le capitaine',
      availability: {
        monday: { available: true, slots: ['09:00-17:00'] },
        tuesday: { available: true, slots: ['09:00-17:00'] },
        wednesday: { available: true, slots: ['09:00-17:00'] },
        thursday: { available: true, slots: ['09:00-17:00'] },
        friday: { available: true, slots: ['09:00-17:00'] },
        saturday: { available: true, slots: ['10:00-18:00'] },
        sunday: { available: true, slots: ['10:00-18:00'] }
      },
      photos: ['yacht-charter-1.jpg', 'yacht-charter-2.jpg'],
      status: 'active'
    },
    {
      id: 'service-002',
      name: 'Sunset Cruise',
      description: 'Croisière romantique au coucher du soleil',
      duration: '3 heures',
      minAge: 12,
      maxAge: null,
      minGuests: 2,
      maxGuests: 8,
      price: 1200,
      currency: 'EUR',
      commission: 20, // Commission spécifique de 20%
      conditions: 'Réservation requise 24h à l\'avance',
      availability: {
        monday: { available: false, slots: [] },
        tuesday: { available: true, slots: ['17:00-20:00'] },
        wednesday: { available: true, slots: ['17:00-20:00'] },
        thursday: { available: true, slots: ['17:00-20:00'] },
        friday: { available: true, slots: ['17:00-20:00'] },
        saturday: { available: true, slots: ['17:00-20:00'] },
        sunday: { available: true, slots: ['17:00-20:00'] }
      },
      photos: ['sunset-cruise-1.jpg'],
      status: 'active'
    },
    {
      id: 'service-003',
      name: 'Fishing Experience',
      description: 'Sortie pêche au gros avec matériel professionnel',
      duration: '6 heures',
      minAge: 8,
      maxAge: null,
      minGuests: 1,
      maxGuests: 6,
      price: 1800,
      currency: 'EUR',
      commission: 25, // Commission spécifique de 25%
      conditions: 'Matériel de pêche inclus, licence non requise',
      availability: {
        monday: { available: true, slots: ['06:00-12:00', '13:00-19:00'] },
        tuesday: { available: true, slots: ['06:00-12:00', '13:00-19:00'] },
        wednesday: { available: true, slots: ['06:00-12:00', '13:00-19:00'] },
        thursday: { available: true, slots: ['06:00-12:00', '13:00-19:00'] },
        friday: { available: true, slots: ['06:00-12:00', '13:00-19:00'] },
        saturday: { available: false, slots: [] },
        sunday: { available: false, slots: [] }
      },
      photos: ['fishing-1.jpg', 'fishing-2.jpg', 'fishing-3.jpg'],
      status: 'active'
    },
    {
      id: 'service-004',
      name: 'Diving Excursion',
      description: 'Plongée sous-marine avec instructeur certifié',
      duration: '4 heures',
      minAge: 16,
      maxAge: 65,
      minGuests: 2,
      maxGuests: 4,
      price: 980,
      currency: 'EUR',
      commission: null,
      conditions: 'Certification PADI requise ou baptême disponible',
      availability: {
        monday: { available: true, slots: ['08:00-12:00', '14:00-18:00'] },
        tuesday: { available: true, slots: ['08:00-12:00', '14:00-18:00'] },
        wednesday: { available: true, slots: ['08:00-12:00', '14:00-18:00'] },
        thursday: { available: true, slots: ['08:00-12:00', '14:00-18:00'] },
        friday: { available: true, slots: ['08:00-12:00', '14:00-18:00'] },
        saturday: { available: true, slots: ['09:00-13:00'] },
        sunday: { available: false, slots: [] }
      },
      photos: ['diving-1.jpg'],
      status: 'active'
    }
  ]);

  // Données des réservations
  const reservations = [
    {
      id: 'RES-2024-001',
      serviceId: 'service-001',
      serviceName: 'Day Charter',
      clientName: 'Marie Dubois',
      clientEmail: 'marie.dubois@email.com',
      date: '2024-10-15',
      time: '09:00',
      duration: '8 heures',
      guests: 8,
      amount: 2500,
      commission: partner.generalCommission,
      commissionAmount: 2500 * (partner.generalCommission / 100),
      status: 'confirmed',
      paymentStatus: 'paid',
      paymentBy: 'Privia', // Qui a effectué le paiement
      villaReservationId: 'RES-VIL-2024-567',
      villaName: 'Villa Paradise',
      notes: 'Anniversaire de mariage - demande champagne',
      createdAt: '2024-09-20'
    },
    {
      id: 'RES-2024-002',
      serviceId: 'service-002',
      serviceName: 'Sunset Cruise',
      clientName: 'John Smith',
      clientEmail: 'john.smith@email.com',
      date: '2024-10-18',
      time: '17:00',
      duration: '3 heures',
      guests: 4,
      amount: 1200,
      commission: 20, // Commission spécifique
      commissionAmount: 1200 * 0.20,
      status: 'pending',
      paymentStatus: 'pending',
      paymentBy: null,
      villaReservationId: 'RES-VIL-2024-568',
      villaName: 'Villa Azure Dreams',
      notes: 'Première visite à St-Barth',
      createdAt: '2024-09-22'
    },
    {
      id: 'RES-2024-003',
      serviceId: 'service-003',
      serviceName: 'Fishing Experience',
      clientName: 'Alessandro Ferrari',
      clientEmail: 'alessandro@email.com',
      date: '2024-10-20',
      time: '06:00',
      duration: '6 heures',
      guests: 3,
      amount: 1800,
      commission: 25, // Commission spécifique
      commissionAmount: 1800 * 0.25,
      status: 'confirmed',
      paymentStatus: 'paid',
      paymentBy: 'Client Direct',
      villaReservationId: 'RES-VIL-2024-569',
      villaName: 'Villa Sunset Bay',
      notes: 'Expérience pêche au gros',
      createdAt: '2024-09-25'
    },
    {
      id: 'RES-2024-004',
      serviceId: 'service-001',
      serviceName: 'Day Charter',
      clientName: 'Sophie Martin',
      clientEmail: 'sophie@email.com',
      date: '2024-09-28',
      time: '10:00',
      duration: '8 heures',
      guests: 6,
      amount: 2500,
      commission: partner.generalCommission,
      commissionAmount: 2500 * (partner.generalCommission / 100),
      status: 'completed',
      paymentStatus: 'paid',
      paymentBy: 'Privia',
      villaReservationId: 'RES-VIL-2024-570',
      villaName: 'Villa Ocean View',
      notes: 'Sortie famille - très satisfaits',
      createdAt: '2024-09-10'
    },
    {
      id: 'RES-2024-005',
      serviceId: 'service-004',
      serviceName: 'Diving Excursion',
      clientName: 'Thomas Weber',
      clientEmail: 'thomas@email.com',
      date: '2024-09-30',
      time: '08:00',
      duration: '4 heures',
      guests: 2,
      amount: 980,
      commission: partner.generalCommission,
      commissionAmount: 980 * (partner.generalCommission / 100),
      status: 'cancelled',
      paymentStatus: 'refunded',
      paymentBy: 'Privia',
      villaReservationId: 'RES-VIL-2024-571',
      villaName: 'Villa Tranquility',
      notes: 'Annulation météo',
      createdAt: '2024-09-15'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'completed': return 'bg-blue-100 text-blue-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'paid': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'refunded': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getPaymentByColor = (paymentBy) => {
    switch (paymentBy) {
      case 'Privia': return 'bg-blue-100 text-blue-800';
      case 'Client Direct': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const generateServiceImage = (serviceName, index = 0) => {
    const colors = {
      'Day Charter': ['#1e3a5f', '#c9a961'],
      'Sunset Cruise': ['#ff6b35', '#f7971e'],
      'Fishing Experience': ['#4a90a4', '#50c9c3'],
      'Diving Excursion': ['#2c5282', '#63b3ed']
    };
    
    const serviceColors = colors[serviceName] || ['#4a5568', '#a0aec0'];
    const bgColor = serviceColors[index % serviceColors.length];
    
    return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 200'%3E%3Cdefs%3E%3ClinearGradient id='grad${index}' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:${encodeURIComponent(bgColor)};stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:${encodeURIComponent(serviceColors[1])};stop-opacity:0.8' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='300' height='200' fill='url(%23grad${index})' /%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' fill='white' font-size='14' font-family='Arial'%3E${serviceName}%3C/text%3E%3C/svg%3E`;
  };

  const formatHours = (hours) => {
    return hours.split('-').map(h => h).join(' - ');
  };

  const handleSaveCommission = () => {
    // Sauvegarder la commission générale
    setEditingCommission(false);
    // Ici on ferait l'appel API pour sauvegarder
  };

  const handleServiceEdit = (service) => {
    setEditingService(service);
  };

  const handleServiceSave = () => {
    // Sauvegarder les modifications du service
    setEditingService(null);
    // Ici on ferait l'appel API pour sauvegarder
  };

  const totalReservations = reservations.length;
  const confirmedReservations = reservations.filter(r => r.status === 'confirmed').length;
  const totalRevenue = reservations.reduce((sum, r) => r.status !== 'cancelled' ? sum + r.amount : sum, 0);
  const totalCommissions = reservations.reduce((sum, r) => r.status !== 'cancelled' ? sum + r.commissionAmount : sum, 0);

  return (
    <div className="partner-detail min-h-screen bg-gray-50">
      {showServiceDetail ? (
        <ServiceDetail 
          service={selectedService} 
          partner={partner}
          onBack={() => {
            setShowServiceDetail(false);
            setSelectedService(null);
          }}
          onSave={(updatedService) => {
            // Ici on mettrait à jour les services
            console.log('Service updated:', updatedService);
            setShowServiceDetail(false);
            setSelectedService(null);
          }}
        />
      ) : (
        <>
          {/* Header */}
          <div className="bg-white border-b border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={onBack}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
            >
              <ArrowLeft size={20} />
              <span>Retour</span>
            </button>
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center text-3xl">
                {partner.icon}
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800">{partner.name}</h1>
                <div className="flex items-center space-x-4 mt-1">
                  <div className="flex items-center space-x-1">
                    <MapPin size={16} className="text-gray-400" />
                    <span className="text-sm text-gray-600">{partner.location}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    {Array.from({ length: 5 }, (_, i) => (
                      <Star
                        key={i}
                        size={14}
                        className={i < partner.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}
                      />
                    ))}
                    <span className="text-sm text-gray-600 ml-2">({partner.reviewsCount} avis)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <button className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
              <MessageSquare size={18} />
              <span>WhatsApp</span>
            </button>
            <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              <Phone size={18} />
              <span>Appeler</span>
            </button>
          </div>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <Calendar className="text-blue-600" size={20} />
              <span className="text-xs text-blue-600">Total</span>
            </div>
            <div className="text-xl font-bold text-gray-800">{totalReservations}</div>
            <div className="text-sm text-gray-600">Réservations</div>
          </div>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <CheckCircle className="text-green-600" size={20} />
              <span className="text-xs text-green-600">Confirmées</span>
            </div>
            <div className="text-xl font-bold text-green-600">{confirmedReservations}</div>
            <div className="text-sm text-gray-600">En cours</div>
          </div>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <Euro className="text-yellow-600" size={20} />
              <span className="text-xs text-yellow-600">Revenus</span>
            </div>
            <div className="text-xl font-bold text-yellow-600">€{totalRevenue.toLocaleString()}</div>
            <div className="text-sm text-gray-600">2024</div>
          </div>
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <Percent className="text-purple-600" size={20} />
              <span className="text-xs text-purple-600">Commissions</span>
            </div>
            <div className="text-xl font-bold text-purple-600">€{totalCommissions.toLocaleString()}</div>
            <div className="text-sm text-gray-600">Générées</div>
          </div>
        </div>
      </div>

      <div className="p-6">
        {/* Onglets */}
        <div className="bg-white rounded-lg border border-gray-200 mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {[
                { id: 'overview', label: 'Vue d\'ensemble', icon: Eye },
                { id: 'services', label: 'Prestations', icon: Settings },
                { id: 'reservations', label: 'Réservations', icon: Calendar },
                { id: 'commissions', label: 'Commissions', icon: Percent },
                { id: 'gallery', label: 'Galerie', icon: Camera }
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 py-4 border-b-2 font-medium text-sm ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <tab.icon size={18} />
                  <span>{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {/* Onglet Vue d'ensemble */}
            {activeTab === 'overview' && (
              <div className="space-y-8">
                {/* Section en-tête avec statistiques */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="bg-blue-600 p-3 rounded-lg">
                        <Calendar className="text-white" size={24} />
                      </div>
                      <span className="text-sm font-medium text-blue-600">Total</span>
                    </div>
                    <div className="text-2xl font-bold text-gray-800 mb-1">{totalReservations}</div>
                    <div className="text-sm text-gray-600">Réservations</div>
                    <div className="text-xs text-blue-600 mt-2">+12% ce mois</div>
                  </div>

                  <div className="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="bg-green-600 p-3 rounded-lg">
                        <CheckCircle className="text-white" size={24} />
                      </div>
                      <span className="text-sm font-medium text-green-600">Confirmées</span>
                    </div>
                    <div className="text-2xl font-bold text-green-600 mb-1">{confirmedReservations}</div>
                    <div className="text-sm text-gray-600">En cours</div>
                    <div className="text-xs text-green-600 mt-2">85% taux confirmation</div>
                  </div>

                  <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="bg-yellow-600 p-3 rounded-lg">
                        <Euro className="text-white" size={24} />
                      </div>
                      <span className="text-sm font-medium text-yellow-600">Revenus</span>
                    </div>
                    <div className="text-2xl font-bold text-yellow-600 mb-1">€{totalRevenue.toLocaleString()}</div>
                    <div className="text-sm text-gray-600">2024</div>
                    <div className="text-xs text-yellow-600 mt-2">+24% vs 2023</div>
                  </div>

                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-3">
                      <div className="bg-purple-600 p-3 rounded-lg">
                        <Percent className="text-white" size={24} />
                      </div>
                      <span className="text-sm font-medium text-purple-600">Commissions</span>
                    </div>
                    <div className="text-2xl font-bold text-purple-600 mb-1">€{totalCommissions.toLocaleString()}</div>
                    <div className="text-sm text-gray-600">Générées</div>
                    <div className="text-xs text-purple-600 mt-2">
                      {totalRevenue > 0 ? ((totalCommissions / totalRevenue) * 100).toFixed(1) : 0}% taux moyen
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {/* Informations générales */}
                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 rounded-t-xl">
                      <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                        <User className="mr-3 text-blue-600" size={24} />
                        Informations Générales
                      </h3>
                    </div>
                    <div className="p-6 space-y-6">
                      <div className="grid grid-cols-1 gap-4">
                        <div className="flex items-start space-x-3">
                          <div className="bg-blue-100 p-2 rounded-lg">
                            <User className="text-blue-600" size={16} />
                          </div>
                          <div className="flex-1">
                            <label className="text-sm font-medium text-gray-500">Contact Principal</label>
                            <div className="font-semibold text-gray-800">{partner.contact.manager}</div>
                          </div>
                        </div>

                        <div className="flex items-start space-x-3">
                          <div className="bg-green-100 p-2 rounded-lg">
                            <Mail className="text-green-600" size={16} />
                          </div>
                          <div className="flex-1">
                            <label className="text-sm font-medium text-gray-500">Email</label>
                            <div className="font-semibold text-gray-800">{partner.contact.email}</div>
                          </div>
                        </div>

                        <div className="flex items-start space-x-3">
                          <div className="bg-yellow-100 p-2 rounded-lg">
                            <Phone className="text-yellow-600" size={16} />
                          </div>
                          <div className="flex-1">
                            <label className="text-sm font-medium text-gray-500">Téléphone</label>
                            <div className="font-semibold text-gray-800">{partner.contact.phone}</div>
                          </div>
                        </div>

                        <div className="flex items-start space-x-3">
                          <div className="bg-purple-100 p-2 rounded-lg">
                            <MapPin className="text-purple-600" size={16} />
                          </div>
                          <div className="flex-1">
                            <label className="text-sm font-medium text-gray-500">Adresse</label>
                            <div className="font-semibold text-gray-800">
                              {partner.address.street}<br />
                              {partner.address.postalCode} {partner.address.city}<br />
                              <span className="text-blue-600">{partner.address.country}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Commission générale */}
                  <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 rounded-t-xl">
                      <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                        <Percent className="mr-3 text-green-600" size={24} />
                        Commission Générale
                      </h3>
                    </div>
                    <div className="p-6">
                      {editingCommission ? (
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Taux de commission (%)
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={generalCommission}
                                onChange={(e) => setGeneralCommission(Number(e.target.value))}
                                className="w-full pl-4 pr-8 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold"
                                step="0.1"
                                min="0"
                                max="100"
                              />
                              <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">%</div>
                            </div>
                          </div>
                          <div className="flex space-x-3">
                            <button
                              onClick={handleSaveCommission}
                              className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                            >
                              <Save size={16} />
                              <span>Sauvegarder</span>
                            </button>
                            <button
                              onClick={() => {
                                setGeneralCommission(partner.generalCommission);
                                setEditingCommission(false);
                              }}
                              className="flex items-center space-x-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                            >
                              <X size={16} />
                              <span>Annuler</span>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="text-center">
                          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 mb-4">
                            <div className="text-4xl font-bold text-green-600 mb-2">{generalCommission}%</div>
                            <div className="text-sm text-gray-600 mb-4">
                              Appliquée par défaut sur toutes les prestations<br />
                              sauf configuration spécifique
                            </div>
                          </div>
                          <button
                            onClick={() => setEditingCommission(true)}
                            className="flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors mx-auto"
                          >
                            <Edit size={16} />
                            <span>Modifier la commission</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Horaires d'ouverture */}
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                  <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 rounded-t-xl">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                      <Clock className="mr-3 text-indigo-600" size={24} />
                      Horaires d'Ouverture
                    </h3>
                  </div>
                  <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
                      {Object.entries(partner.businessHours).map(([dayKey, hours]) => {
                        const dayNames = {
                          monday: 'Lundi',
                          tuesday: 'Mardi', 
                          wednesday: 'Mercredi',
                          thursday: 'Jeudi',
                          friday: 'Vendredi',
                          saturday: 'Samedi',
                          sunday: 'Dimanche'
                        };
                        
                        return (
                          <div key={dayKey} className="text-center p-4 bg-gray-50 rounded-lg">
                            <div className="font-semibold text-gray-800 mb-2">
                              {dayNames[dayKey]}
                            </div>
                            <div className={`text-sm px-3 py-2 rounded-full ${
                              hours.closed 
                                ? 'bg-red-100 text-red-800' 
                                : 'bg-green-100 text-green-800'
                            }`}>
                              {hours.closed ? 'Fermé' : `${hours.open} - ${hours.close}`}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Informations bancaires */}
                <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                  <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 rounded-t-xl">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                      <CreditCard className="mr-3 text-blue-600" size={24} />
                      Informations Bancaires
                    </h3>
                  </div>
                  <div className="p-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-500 mb-2">RIB / IBAN</label>
                          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                            <div className="font-mono text-sm text-gray-800 break-all">
                              {partner.bankingInfo.rib}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-500 mb-2">Banque</label>
                          <div className="font-semibold text-gray-800 text-lg">{partner.bankingInfo.bankName}</div>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-500 mb-2">Titulaire du compte</label>
                          <div className="font-semibold text-gray-800">{partner.bankingInfo.accountHolder}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Onglet Prestations */}
            {activeTab === 'services' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Gestion des Prestations ({services.length})
                  </h3>
                  <button
                    onClick={() => setShowAddService(true)}
                    className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    <Plus size={18} />
                    <span>Nouvelle Prestation</span>
                  </button>
                </div>

                {/* Grid des prestations - 3 par ligne */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {services.map((service) => (
                    <div 
                      key={service.id} 
                      className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-200 cursor-pointer hover:-translate-y-1"
                      onClick={() => {
                        setSelectedService(service);
                        setShowServiceDetail(true);
                      }}
                    >
                      {/* Image de la prestation */}
                      <div className="relative h-48">
                        <img 
                          src={generateServiceImage(service.name, 0)}
                          alt={service.name}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute top-3 left-3">
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                            service.status === 'active' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {service.status === 'active' ? 'Actif' : 'Inactif'}
                          </span>
                        </div>
                        <div className="absolute top-3 right-3">
                          <span className="bg-black bg-opacity-50 text-white px-2 py-1 rounded text-xs">
                            €{service.price.toLocaleString()}
                          </span>
                        </div>
                        <div className="absolute bottom-3 right-3">
                          <span className="bg-blue-600 text-white px-2 py-1 rounded text-xs">
                            {service.commission ? `${service.commission}%` : `${generalCommission}%`}
                          </span>
                        </div>
                      </div>

                      {/* Contenu de la carte */}
                      <div className="p-4">
                        <div className="mb-3">
                          <h4 className="text-lg font-semibold text-gray-800 mb-1">{service.name}</h4>
                          <p className="text-sm text-gray-600 line-clamp-2">{service.description}</p>
                        </div>

                        {/* Informations principales */}
                        <div className="grid grid-cols-3 gap-3 mb-4">
                          <div className="text-center">
                            <Clock className="w-4 h-4 mx-auto mb-1 text-gray-600" />
                            <div className="text-xs font-medium text-gray-800">{service.duration}</div>
                          </div>
                          <div className="text-center">
                            <Users className="w-4 h-4 mx-auto mb-1 text-gray-600" />
                            <div className="text-xs font-medium text-gray-800">
                              {service.minGuests}-{service.maxGuests}
                            </div>
                          </div>
                          <div className="text-center">
                            <Calendar className="w-4 h-4 mx-auto mb-1 text-gray-600" />
                            <div className="text-xs font-medium text-gray-800">
                              {Object.values(service.availability).filter(a => a.available).length}/7j
                            </div>
                          </div>
                        </div>

                        {/* Conditions */}
                        <div className="mb-4">
                          <div className="text-xs text-gray-500 mb-1">Conditions</div>
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-gray-600">
                              Âge: {service.minAge > 0 ? `${service.minAge}+` : 'Tout âge'}
                              {service.maxAge ? ` - ${service.maxAge}` : ''}
                            </span>
                            <span className="font-medium text-blue-600">
                              Commission: €{((service.commission || generalCommission) * service.price / 100).toFixed(0)}
                            </span>
                          </div>
                        </div>

                        {/* Disponibilités cette semaine */}
                        <div className="border-t pt-3">
                          <div className="text-xs text-gray-500 mb-2">Disponibilités</div>
                          <div className="flex justify-center space-x-1">
                            {['L', 'M', 'M', 'J', 'V', 'S', 'D'].map((day, index) => {
                              const dayKey = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'][index];
                              const isAvailable = service.availability[dayKey]?.available;
                              return (
                                <div 
                                  key={day}
                                  className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium ${
                                    isAvailable 
                                      ? 'bg-green-100 text-green-800' 
                                      : 'bg-red-100 text-red-800'
                                  }`}
                                >
                                  {day}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      {/* Bouton d'action au hover */}
                      <div className="absolute inset-0 bg-blue-600 bg-opacity-0 hover:bg-opacity-10 transition-all duration-200 flex items-center justify-center opacity-0 hover:opacity-100 pointer-events-none">
                        <div className="bg-white px-4 py-2 rounded-lg shadow-lg">
                          <span className="text-sm font-medium text-gray-800">Voir les détails</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Message si aucune prestation */}
                {services.length === 0 && (
                  <div className="text-center py-12">
                    <Settings className="mx-auto h-12 w-12 text-gray-400 mb-4" />
                    <h3 className="text-lg font-medium text-gray-800 mb-2">Aucune prestation</h3>
                    <p className="text-gray-600 mb-4">Commencez par ajouter une première prestation</p>
                    <button
                      onClick={() => setShowAddService(true)}
                      className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 mx-auto"
                    >
                      <Plus size={18} />
                      <span>Ajouter une prestation</span>
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Onglet Réservations */}
            {activeTab === 'reservations' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Historique des Réservations ({reservations.length})
                  </h3>
                  <div className="flex items-center space-x-2">
                    <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm">
                      <option value="all">Tous les statuts</option>
                      <option value="confirmed">Confirmées</option>
                      <option value="pending">En attente</option>
                      <option value="completed">Terminées</option>
                      <option value="cancelled">Annulées</option>
                    </select>
                  </div>
                </div>

                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-50">
                        <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          <th className="px-6 py-3">Réservation</th>
                          <th className="px-6 py-3">Prestation</th>
                          <th className="px-6 py-3">Client</th>
                          <th className="px-6 py-3">Date & Heure</th>
                          <th className="px-6 py-3">Invités</th>
                          <th className="px-6 py-3">Montant</th>
                          <th className="px-6 py-3">Commission</th>
                          <th className="px-6 py-3">Statut</th>
                          <th className="px-6 py-3">Paiement & Source</th>
                          <th className="px-6 py-3">Villa</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {reservations.map((reservation) => (
                          <tr key={reservation.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4">
                              <div className="font-medium text-blue-600">{reservation.id}</div>
                              <div className="text-xs text-gray-500">
                                Villa: {reservation.villaReservationId}
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-gray-900">{reservation.serviceName}</div>
                              <div className="text-xs text-gray-500">{reservation.duration}</div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-gray-900">{reservation.clientName}</div>
                              <div className="text-xs text-gray-500">{reservation.clientEmail}</div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-gray-900">
                                {new Date(reservation.date).toLocaleDateString('fr-FR')}
                              </div>
                              <div className="text-xs text-gray-500">{reservation.time}</div>
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-900">
                              {reservation.guests} personnes
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-gray-900">€{reservation.amount.toLocaleString()}</div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-blue-600">
                                €{reservation.commissionAmount.toLocaleString()}
                              </div>
                              <div className="text-xs text-gray-500">{reservation.commission}%</div>
                            </td>
                            <td className="px-6 py-4">
                              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(reservation.status)}`}>
                                {reservation.status === 'confirmed' ? 'Confirmée' :
                                 reservation.status === 'pending' ? 'En attente' :
                                 reservation.status === 'completed' ? 'Terminée' : 'Annulée'}
                              </span>
                            </td>
                            <td className="px-6 py-4">
                              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getPaymentStatusColor(reservation.paymentStatus)}`}>
                                {reservation.paymentStatus === 'paid' ? 'Payé' :
                                 reservation.paymentStatus === 'pending' ? 'En attente' : 'Remboursé'}
                              </span>
                              {reservation.paymentBy && (
                                <div className="mt-1">
                                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getPaymentByColor(reservation.paymentBy)}`}>
                                    {reservation.paymentBy}
                                  </span>
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4">
                              <div className="font-medium text-gray-900">{reservation.villaName}</div>
                              <div className="text-xs text-blue-600 cursor-pointer hover:text-blue-800">
                                {reservation.villaReservationId}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* Onglet Commissions */}
            {activeTab === 'commissions' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-800">Gestion des Commissions</h3>
                
                <div className="bg-white border border-gray-200 rounded-lg p-6">
                  <h4 className="text-md font-semibold text-gray-800 mb-4">Configuration par Prestation</h4>
                  <div className="space-y-4">
                    {services.map((service) => (
                      <div key={service.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                        <div>
                          <h5 className="font-medium text-gray-800">{service.name}</h5>
                          <p className="text-sm text-gray-600">Prix: €{service.price.toLocaleString()}</p>
                        </div>
                        <div className="flex items-center space-x-4">
                          <div className="text-right">
                            <div className="font-medium text-gray-800">
                              {service.commission ? (
                                <span className="text-blue-600">{service.commission}%</span>
                              ) : (
                                <span className="text-gray-600">{generalCommission}% (défaut)</span>
                              )}
                            </div>
                            <div className="text-xs text-gray-500">
                              Commission: €{((service.commission || generalCommission) * service.price / 100).toFixed(0)}
                            </div>
                          </div>
                          <button className="p-2 text-gray-600 hover:text-blue-600">
                            <Edit size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white border border-gray-200 rounded-lg p-6">
                  <h4 className="text-md font-semibold text-gray-800 mb-4">Résumé Financier</h4>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="text-center p-4 bg-green-50 rounded-lg">
                      <div className="text-2xl font-bold text-green-600">€{totalCommissions.toLocaleString()}</div>
                      <div className="text-sm text-gray-600">Commissions Totales</div>
                    </div>
                    <div className="text-center p-4 bg-blue-50 rounded-lg">
                      <div className="text-2xl font-bold text-blue-600">{totalReservations}</div>
                      <div className="text-sm text-gray-600">Réservations</div>
                    </div>
                    <div className="text-center p-4 bg-yellow-50 rounded-lg">
                      <div className="text-2xl font-bold text-yellow-600">
                        {totalRevenue > 0 ? ((totalCommissions / totalRevenue) * 100).toFixed(1) : 0}%
                      </div>
                      <div className="text-sm text-gray-600">Taux Moyen</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Onglet Galerie */}
            {activeTab === 'gallery' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-800">Galerie Photos</h3>
                  <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                    <Upload size={18} />
                    <span>Ajouter Photos</span>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {/* Photos générales du partenaire */}
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <div className="bg-gray-200 rounded-lg h-48 flex items-center justify-center mb-3">
                      <Camera className="text-gray-400" size={32} />
                    </div>
                    <h4 className="font-medium text-gray-800">Photo principale</h4>
                    <p className="text-sm text-gray-600">Image de présentation du partenaire</p>
                  </div>

                  {/* Photos par service */}
                  {services.map((service) => (
                    <div key={service.id} className="bg-white border border-gray-200 rounded-lg p-4">
                      <div className="bg-gray-200 rounded-lg h-48 flex items-center justify-center mb-3">
                        <Camera className="text-gray-400" size={32} />
                      </div>
                      <h4 className="font-medium text-gray-800">{service.name}</h4>
                      <p className="text-sm text-gray-600">{service.photos.length} photo(s)</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
        </>
      )}
    </div>
  );
};

export default PartnerDetail;